<template>
  <div v-show="isReady" class="form-page_unnax">
    <div class="tooltip" v-if="history[currentStep].field.tooltip">
      <span class="icon icon-info-line"><info-icon/></span>
      <p class="tooltip-text" v-html="history[currentStep].field.tooltip">
      </p>
    </div>
    <div id="unnax-container" :class="{whiteBG: field.name === 'wenance_bank_reader'}">
      <div class="close-btn-hider"></div>
      <iframe id="unnax"></iframe>
    </div>
    <div v-if="!onlineBankingRequired" class="has_declined_unnax_shower"><a id="has_declined_unnax" @click="skipUnnax">NO TENGO BANCO ONLINE</a><br></div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import InfoIcon from '../assetComponents/InfoIcon'
import Crezu from '@/utils/'

export default {
  name: 'Unnax',
  components: { InfoIcon },
  data () {
    return {
      inputVal: null,
      alreadySuccess: false,
      onlineBankingRequired: window.online_banking_required || 0, // written in Confirm step for Moneyman
      isReady: false,
    }
  },
  computed: {
    ...mapState({
      history: state => state.history,
      currentStep: state => state.currentStep,
      field: state => state.history[state.currentStep],
      config: state => state.config,
      isDev: state => state.isDev,
      leadId: state => state.additionalParams.lead_id || localStorage.getItem('leadId') || localStorage.getItem('lead_id')
    })
  },
  mounted () {
    // TODO: delete moneyman additional
    this.$store.dispatch('sendCrezuEvent', { id: 24, data: { sub2: 'moneyman_unnax', sub3: 'moneyman_unnax_inited' } })
    this.$store.commit('CHANGE_ADDITIONAL_PARAMS', { online_banking_provided: false, online_banking_required: this.onlineBankingRequired })

    if (!this.onlineBankingRequired) {
      this.skipUnnax()
      return
    }

    if (this.field.name === 'moneyman_online_banking') {
      // mounted hook
      const url = localStorage.getItem('unnax_url')
      if (url === 'error') this.skipUnnax()
      this.initializeUnnax(url)
    } else if (this.field.name === 'wenance_bank_reader') {
      this.$store.dispatch('getCustomerToken', this.field.name).then((data) => {
        try {
          const url = JSON.parse(data).bank_login_render_url
          console.log(url)
          this.initializeUnnax(url)
        } catch (e) {
          this.skipUnnax()
        }
      })
    }

    this.isReady = true
  },
  methods: {
    initializeUnnax (url) {
      document.getElementById('unnax').src = url
      const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent'
      const eventer = window[eventMethod]
      const messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message'
      let vm = this
      // Listen to message from child window
      eventer(messageEvent, function (e) {
        if (e.data === 'unnax:aggregation:done') {
          if (vm.alreadySuccess) return // fix for just 1 event handling
          vm.alreadySuccess = true
          console.log('UNNAX DONE:', e)
          if (vm.field.name === 'moneyman_online_banking') {
            try {
              window.jslabApi.manuallyComplete.dispatchEvent(new Event('click'))
            } catch (e) {
            }
            vm.$store.commit('UPDATE_FIELD', { isValid: true })
            vm.$store.commit('CHANGE_ADDITIONAL_PARAMS', {
              online_banking_provided: true,
              juicescore_session_id: localStorage.getItem('juicescore_session_id'),
            })
            vm.$store.dispatch('nextStepPrepare', +1)
          } else if (vm.field.name === 'wenance_bank_reader') {
            vm.$store.commit('UPDATE_FIELD', { isValid: true, value: 1 })
            vm.$store.dispatch('nextStepPrepare', +1)
          }

          vm.$store.dispatch('sendCrezuEvent', { id: 24, data: { sub2: 'moneyman_unnax', sub3: 'moneyman_unnax_completed' } })
        } else if (e.data === 'unnax:aggregation:fail') {
          console.log('UNNAX FAIL: ', e)
          vm.$store.dispatch('sendCrezuEvent', { id: 24, data: { sub2: 'moneyman_unnax', sub3: 'moneyman_unnax_validation' } })

          vm.skipUnnax()
        }
      })
    },
    skipUnnax () {
      this.$store.commit('UPDATE_FIELD', { isValid: true, value: 0 })
      if (this.field.name === 'moneyman_online_banking') this.$store.commit('CHANGE_ADDITIONAL_PARAMS', { online_banking_provided: false })
      this.$store.dispatch('nextStepPrepare', +1)

      this.$store.dispatch('sendCrezuEvent', { id: 24, data: { sub2: 'moneyman_unnax', sub3: 'moneyman_unnax_skip' } })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/unnax";
  #unnax-container.whiteBG {
    background-color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/fields/Unnax.vue